import { render, staticRenderFns } from "./boletim.vue?vue&type=template&id=f5abfb28&"
import script from "./boletim.vue?vue&type=script&lang=js&"
export * from "./boletim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports